import * as THREE from 'three';
import React, { useRef } from 'react'
import { RoundedBox, Text } from '@react-three/drei'
import { useFrame } from '@react-three/fiber';

import { const_var } from '../../../../redux/reducers/reducer';
import { getDistanceTwoPoints } from '../../../../utils/Functions';

const DimensionValue = ({ type, dir, position, rotation, value, slopeAngle, checkBackSide, cmpPos }) => {
    const ref_measure = useRef();
    const panelLength = [...value].length * 0.4;
    const panelHeight = 0.7;
    const panelThickness = 0.15;

    const factorOffset = 80;

    let newPosX = position[0];
    let newPosY = position[1];
    let newPosZ = position[2];


    useFrame(() => {
        if (ref_measure.current) {
            const distance = (const_var.controls !== undefined && const_var.controls.getDistance !== undefined && const_var.controls.object !== undefined && cmpPos) ? getDistanceTwoPoints(const_var.controls.object.position, cmpPos) : factorOffset;

            let scaleFactor = distance / factorOffset;
            if (scaleFactor <= 1) scaleFactor = 1;
            
            if (type) {
                if (type === 'window') {
                    if (dir === 'left') {
                        if (rotation[2] === 0) {
                            newPosX = position[0] - (panelLength / 2 * scaleFactor * 1.5 + 0.2);
                            newPosY =  position[1];
                        } else {
                            newPosX = position[0] - 0.1;
                        }
                    }
                    else if (dir === 'right') {
                        if (rotation[2] === 0) {
                            newPosX = position[0] + (panelLength / 2 * scaleFactor * 1.5 + 0.2);
                            newPosY = position[1];
                        } else {
                            newPosX = position[0] + 0.1;
                        }
                    }
                    else if (dir === 'top') {
                        newPosY = position[1] + panelHeight * scaleFactor * 1.35;
                    }
                    else if (dir === 'bottom') {
                        newPosY = position[1] - panelHeight * scaleFactor * 1.35
                    }
                } else if (type === 'door') {
                    if (dir === 'left') {
                        if (rotation[2] === 0) {
                            newPosX = position[0] - (panelLength / 2 * scaleFactor * 1.5 + 0.2);
                        } else {
                            newPosX = position[0] - 0.1;
                        }
                    }
                    else if (dir === 'right') {
                        if (rotation[2] === 0) {
                            newPosX = position[0] + (panelLength / 2 * scaleFactor * 1.5 + 0.2);
                        } else {
                            newPosX = position[0] + 0.1;
                        }
                    }
                    else if (dir === 'top') {
                        newPosY = position[1] + panelHeight * scaleFactor * 1.35;
                    }
                }
            }
            
            ref_measure.current.position.set(newPosX, newPosY, newPosZ);
            ref_measure.current.scale.set(scaleFactor, scaleFactor, 1);
        }
    });

    return (
        <group ref={ref_measure} rotation={rotation}>
            <group name='measurement_value_group' position={[0, 0.5, 0.2]} rotation={[-THREE.MathUtils.degToRad(slopeAngle), 0, 0]}>
                <RoundedBox args={[panelLength, panelHeight, panelThickness]} radius={0.075}  scale={[1, 1, 0.1]}>
                    <meshStandardMaterial color={'#2270B3'} />
                </RoundedBox>
                <Text
                    name='measurement_value_front'
                    color="white"
                    anchorX="center" 
                    anchorY="middle" 
                    fontSize={0.5}
                    fontWeight={500}
                    position={[0,0,0.02]}
                >
                    <meshBasicMaterial fog={false} toneMapped={false}  />
                    {value}
                </Text>
                {checkBackSide &&
                    <Text
                        name='measurement_value_back'
                        color="white"
                        anchorX="center" 
                        anchorY="middle" 
                        fontSize={0.5}
                        fontWeight={500}
                        position={[0,0,-0.02]}
                        rotation={[0, Math.PI, 0]}
                    >
                        <meshBasicMaterial fog={false} toneMapped={false}  />
                        {value}
                    </Text>
                }
            </group>
        </group>
    )
}

export default DimensionValue